import styled from "styled-components";
import { Checkbox } from "antd";

export const StyledCheckbox = styled(Checkbox)`
  color: ${({ checked, theme }) => checked && theme.primaryColor};
  transition: color 0.3s;
`;
